<template>
    <div>
        <navigation-bar Back Bell/>
        <div class="main message-form">
            <h3>{{brandName}} {{storeName}}</h3>
            <category-header title="類別" class="mb-2"/>
            <el-select v-model="messageTypeValue" placeholder="請選擇類別" class="border-input">
                <el-option
                        v-for="item in messageTypeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"/>
            </el-select>

            <category-header title="選擇分店" class="mb-2" v-show="false"/>
            <el-select v-model="branchValue" placeholder="請選擇分店" class="border-input" v-show="false" :disabled="isLockBranchSelector">
                <el-option
                        v-for="item in branchOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"/>
            </el-select>

            <category-header title="留言內容" class="mb-2"/>
            <el-input
                    class="border-input"
                    placeholder="請輸入標題"
                    v-model="messageTitle"
                    maxlength="30"
                    show-word-limit/>
            <el-input
                    class="mt-3 border-input"
                    placeholder="請輸入內文"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 8}"
                    v-model="messageContent"/>

            <category-header title="上傳圖片（上限5張）" class="mb-2"/>
            <el-upload
                    action="#"
                    accept=".jpg, .png, .jpeg"
                    list-type="picture-card"
                    :limit="maxImageLimit"
                    :on-remove="handleRemove"
                    :on-change="onFileChange"
                    :on-exceed="onFileMax"
                    :file-list="fileList"
                    :auto-upload="false"
                    :multiple="true"
                    :disabled="disableFilePicker"
                    class="upload-custom mb-5">
                <i slot="default" class="el-icon-plus" />
                <div slot="file" slot-scope="{file}">
                    <el-image fit="cover" :src="file.url" @click.native="handlePictureCardPreview(file)"/>
                    <i class="el-icon-error delete-btn"  @click="handleRemove(file)"/>
                </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible"
                       class="stall-photo-pop">
                <Banner :list="fileList"
                        :fileNum="bannerPreviewImageIndex"
                        @value-close="closeBannerDialog"
                        @value-remove="handleRemove"/>
            </el-dialog>

            <div class="footer-button">
                <el-button @click="$router.back()" class="cancel" round>取消</el-button>
                <el-button type="primary" round @click="onClickSend">送出</el-button>
            </div>

        </div>
        <comm-dialog :value="dialog.isShowDialog" :outerContent="dialog.dialogMsg"  :isCancel="dialog.cancelable" @result="onCommDialogClose"/>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import CategoryHeader from '@/components/category/Header';
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import CommDialog from '@/components/CommDialog.vue';
    // import * as imageConversion from 'image-conversion';
    import Banner from '@/components/PhotoSlider';

    export default {
        name: "MessageForm",
        components: {
            Banner,
            CategoryHeader,
            Toast,
            CommDialog,
        },
        data() {
            return {
                isLoading: false,
                dialogImageUrl: "",
                dialogVisible: false,
                // disabled: false,
                messageTypeOptions: null  ,     //[ { value: "1", label: "類別1", }, { value: "1", label: "類別1", }, .... ],
                messageTypeValue: "",           //留言類型 (數值)，預設空白字串才不會亂顯示成其他數值

                branchOptions: null, //[ { value: "1", label: "分店1", }, ...],
                branchValue: "",        //分店ID (數值)，預設空白字串才不會亂顯示成其他數值

                isLockBranchSelector: false,    //是否鎖定分店選擇？ true:鎖定
                messageTitle: "",
                messageContent: "",
                maxImageLimit: 5,                   //最大上傳圖檔數量
                fileList: [],
                bannerPreviewImageIndex: 0,           //要預覽的圖的索引
                dialogWidth: "350px",
                fileResults: [],
                storeId: this.$route.query.storeId? Number(this.$route.query.storeId): '',                 //要在哪間店留言？
                brandName: '',                  //顯示用，品牌名稱
                storeName: '',                  //顯示用，店家名稱
                dialog: {
                    isShowDialog: false,
                    dialogMsg: '',
                    cancelable: false,
                },
                disableFilePicker: false,               //是否停用上傳圖片按鈕？
            };
        },
        created() {

        },
        mounted() {

            let self = this;
            this.callGetStoreInfoByIdApi(self.storeId, 0, 0)
                .then(
                    self.callGetTypeListApi
                )
                .then(
                    self.callGetStoreListApi
                )
                .then( () => {
                        // 選定預設的店家
                        if (self.$public.notNull(self.branchOptions) && self.branchOptions.length > 0) {
                            self.branchOptions.forEach((element, index) => {
                                if (element.id === self.storeId) {
                                    //當店家 id存在的時候才給預設值
                                    if (self.storeId !== 0) {
                                        self.branchValue = self.storeId;
                                        self.isLockBranchSelector = true;
                                    }
                                }
                            });

                            // console.log(`mounted storeId: ${self.storeId}, branchValue: ${self.branchValue}`);
                        }
                    }
                ).catch( (error) => {
                    self.isLoading = false;
                    self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });

        },
        mutations: {

        },
        methods: {

            /** 送出 */
            onClickSend: function() {
                let self = this;

                // console.log(`onClickSend messageTypeValue: ${self.messageTypeValue}, branchValue: ${self.branchValue}`);
                let isError = this.checkBeforeLeaveMessage(self.messageTypeValue, self.branchValue, self.messageTitle, self.messageContent);
                if ( isError === 0) {
                    self.post(self.messageTypeValue, self.branchValue, self.messageTitle, self.messageContent, self.fileList);

                } else {
                    let errMsg = '';
                    if (isError === 1) {
                        errMsg = '請選擇留言類別';
                    } else if (isError === 2) {
                        errMsg = '請選擇要留言的店家';
                    } else if (isError === 3) {
                        errMsg = '請輸入留言標題';
                    } else if (isError === 4) {
                        errMsg = '請輸入留言內容';
                    }
                    self.$store.commit(mutationTypes.SHOW_TOAST, errMsg);
                }
            },

            /** 留言檢查 */
            checkBeforeLeaveMessage(typeId, storeId, title, content) {
                let error = 0;

                if (typeId <= 0) {
                    error = 1;
                } else if (storeId <= 0) {
                    error = 2;
                } else if (!this.$public.notNull(title) || title === '') {
                    error = 3;
                } else if (!this.$public.notNull(content) || content === '') {
                    error = 4;
                }
                return error;
            },

            /** 圖片預覽 */
            handlePictureCardPreview(file) {
                // this.dialogImageUrl = file.url;
                this.bannerPreviewImageIndex = this.fileList.indexOf(file);
                this.dialogVisible = true;

                //彈窗要改黑色背景
                document.body.classList.add('bg-dark')
            },
            /** 關閉圖片預覽 */
            closeBannerDialog(){
                this.dialogVisible = false;
                //彈窗要改回預設
                document.body.classList.remove('bg-dark')
            },

            /** 文件狀態改變(新增、上傳成功和上傳失敗)時會呼叫 */
            onFileChange: async function(file, fileList) {
                //file結構: {"status":"ready","name":"dayelang.jpg","size":20297,"percentage":0,"uid":0,"raw":{"uid":0},"url":"blob:"}
                // console.log(`onFileChange old file:${JSON.stringify(file)}, \n fileList: ${JSON.stringify(fileList)} \n`);

                let self = this;

                //刪除重複檔案
                for(let i = 0; i < fileList.length - 1; i += 1) {
                    for(let j = 1; j < fileList.length; j += 1) {
                        if( (i!==j) && fileList[i].name === fileList[j].name) {
                            // console.log(`remove file: ${fileList[j].name}`);
                            fileList.splice(j ,1);
                            break
                        }
                    }
                }
                self.fileList = fileList;

                self.disableFilePicker = (self.fileList.length >= self.maxImageLimit);
                // console.log(`disableFilePicker: ${self.disableFilePicker}`);
            },
            /** 移除圖檔 */
            handleRemove(file) {
                this.$delete(this.fileList, this.fileList.indexOf(file));
                this.disableFilePicker = (this.fileList.length >= this.maxImageLimit);

                // console.log(`handleRemove: \n file : ${JSON.stringify(file)} \n fileList : ${JSON.stringify(fileList)} \n selectImageAry : ${JSON.stringify(this.selectImageAry)}`);
            },
            /** 檔案數量上限 */
            onFileMax: function() {
                this.$store.commit(mutationTypes.SHOW_TOAST, `已超出張數上傳上限`);
            },

            /** 檢查檔案 */
            checkFile: async function (files) {
                // let files = e.target.files || e.dataTransfer.files;
                let self = this;
                let fileResults = [];       //檔案陣列

                // 預防檔案為空檔
                if (!files.length) {
                    return undefined;
                } else {

                    //上傳圖片
                    let loadImageFile = async (file) => {
                        await self.readFile(file)
                                    .then((result) => {
                                        return fileResults.push(result.file);
                                    });
                    };

                    let asyncRun = async (fileList) => {
                        for (let file of fileList) {
                            await loadImageFile(file);
                        }
                    };

                    await asyncRun(files).then( () => {
                        return fileResults;
                    })
                }
                return fileResults;
            },

            /** 讀取檔案 */
            readFile: function(file, setImageWidth = 0, setImageHeight = 0) {
                let self = this;
                return new Promise((resolve) => {
                    let file_result = {
                        file: file,
                        imagePreview: '',
                        imageWidth: '',
                        imageHeight: '',
                        status: 'ok'
                    };

                    //檢查檔案大小
                    if (file.size > 2000000) {
                        file_result['status'] = 'size_too_big';
                        return;
                    }

                    let reader = new FileReader();
                    reader.onload = function () {
                        file_result["imagePreview"] = this.result;
                        if (setImageWidth !== 0 && setImageHeight !== 0) {
                            let image = new Image()
                            image.onload = function () {
                                file_result["imageWidth"] = image.width;
                                file_result["imageHeight"] = image.height;
                                // 檢查圖片尺寸
                                if (setImageWidth !== image.width || setImageHeight !== image.height) {
                                    file_result['status'] = 'out_of_size';
                                }
                            }
                            image.src = this.result;
                        }
                        // console.log(`FileReader: file_result : ${JSON.stringify(file_result)}`);
                        resolve(file_result);
                    };
                    // reader.readAsDataURL(file);
                    reader.readAsText(file.raw);
                })
            },

            /** 新增留言 */
            post: function (typeId, storeId, title, content, imageAry) {
                let toUploadImageAry = [];
                let uploadedImageAry = [];
                this.isLoading = true;
                let self = this
                //上傳圖片
                let uploadImageAry = () => {
                    return new Promise((resolve) => {
                        self.isLoading = true;
                        if (imageAry.length > 0) {

                            for (let imageFile of imageAry) {
                                toUploadImageAry.push(imageFile.raw);
                            }

                            self.$http.fetchUpload`${{
                                "file": toUploadImageAry,
                                "folder": "/commentPhoto"
                            }} ${json => {
                                self.isLoading = false;
                                if (json.status) {
                                    if (self.$public.notNull(json.data)) {
                                        json.data.forEach( (element, index) => {
                                            uploadedImageAry.push(element);
                                        });
                                    }
                                }
                                resolve();
                            }}`;
                        } else {
                            resolve();
                        }
                    });
                };
                //fetch 同步
                let asyncRun = async () => {
                    await Promise.all([uploadImageAry()])
                };

                //上傳圖片
                asyncRun().then( ()=>{
                    return self.callAddFeedbackApi(typeId, storeId, title, content, uploadedImageAry);
                })
            },

            /** 取得留言類別清單 */
            callGetTypeListApi : function() {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.isLoading = true;
                    self.$http.fetch`GetFeedbackTypeList${{
                        storeId: self.storeId,
                    }} ${json => {
                        self.isLoading = false;
                        if (self.$public.notNull(json.data)) {
                            self.messageTypeOptions = json.data;
                        }
                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 取得店家清單 */
            callGetStoreListApi : function() {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.isLoading = true;
                    self.$http.fetch`GetFeedbackStoreList${{
                        id: 0,    //篩選用,帶入id會查出分店列表,沒帶(0) 則列出全部
                    }} ${json => {
                        self.isLoading = false;
                        if (self.$public.notNull(json.data)) {
                            self.branchOptions = json.data;
                        }
                        //完畢
                        resolve();
                    }}`;
                });
            },

            /**
             * 新增留言
             * @param: imageAry, 已經上傳的圖回傳後的資料
             * */
            callAddFeedbackApi : function(typeId, storeId, title, content, imageAry) {
                let self = this
                return new Promise(function(resolve, reject) {
                    self.isLoading = true;

                    self.$http.fetchWithAuth`CreateFeedback${{
                        typeId: typeId,    //篩選用,帶入id會查出分店列表,沒帶(0) 則列出全部
                        storeId: storeId,    //
                        title: title,
                        content: content,
                        imageAry: imageAry,
                    }} ${json => {
                        self.isLoading = false;
                        if (json.status) {
                            // console.log(`confirmBookingUrl : ${self.confirmBookingUrl}`);
                            self.showDialog('留言成功', false);
                        } else {
                            self.$store.commit(mutationTypes.SHOW_TOAST, `留言失敗`);
                        }

                        //完畢
                        resolve();
                    }}`;
                });
            },

            /** 呼叫 取得店家資訊api */
            callGetStoreInfoByIdApi (storeId, lng, lat) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetStoreInfoById${{
                        id: storeId,
                        lng: lng,
                        lat: lat,
                    }} ${json => {
                        self.isLoading = false;

                        if (self.$public.notNull(json.data)) {
                            self.storeInfo = json.data;
                            self.brandName = self.storeInfo.brandName;
                            self.storeName = self.storeInfo.name;

                        }
                        resolve();
                    }}`;
                });

            },

            /** 顯示訊息 dialog */
            showDialog: function (msg, cancelable = false) {
                this.dialog.cancelable = cancelable;
                this.dialog.dialogMsg = msg;
                this.dialog.isShowDialog = true;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.dialog.isShowDialog = false;
                this.$router.go(-1);
            },
        },
    };
</script>

<style lang="less" scoped src="@/less/feedback.less"/>